/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddContributorRequest
 */
export interface AddContributorRequest {
    /**
     * 
     * @type {string}
     * @memberof AddContributorRequest
     */
    email?: string;
}

/**
 * Check if a given object implements the AddContributorRequest interface.
 */
export function instanceOfAddContributorRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddContributorRequestFromJSON(json: any): AddContributorRequest {
    return AddContributorRequestFromJSONTyped(json, false);
}

export function AddContributorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddContributorRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function AddContributorRequestToJSON(value?: AddContributorRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

